import {BusinessDetails, ContactDetails, GoogleDetails, MetaTagsProps, SocialMediaProfilesTypes} from "@/types";

export const BUSINESS_NAME: string = "Powered Up Electrical";
export const WEBSITE_URL: string = "poweredupelectrical.com.au";
export const OG_PATH = `${WEBSITE_URL}/images/og/`;
export const defaultMetaTags: MetaTagsProps = {
    title: `${BUSINESS_NAME}`,
    description: "",
    keywords: "",
    url: WEBSITE_URL,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const socialMediaProfiles: SocialMediaProfilesTypes = {
    instaLink: "https://www.instagram.com/",
    instaHandle: "",
    instaPostsLink: "https://www.instagram.com/p/",
    tikTokLink: "https://www.tiktok.com/",
    tikTokHandle: "",
    tikTokPostsLink: "https://www.tiktok.com/",
    facebookLink: "https://www.facebook.com/",
    facebookHandle: "",
    linkedInLink: "https://www.linkedin.com/company/",
    linkedInHandle: "",
    youTubeHandle: "",
    youTubeLink: "https://youtube.com/",
}

export const contactDetails: ContactDetails = {
    contactNumberOne: "0413 999 333",
    contactNumberTwo: "",
    fax:"02 8090 4454",
    contactEmail: "admin@poweredupelectrical.com.au",
}

export const googleDetails: GoogleDetails = {
    googleHandle: "",
    googleLink: "",
    googleMaps: "",
    googleReviewLink: "",
    googleServiceArea: "", //embed link

    areaServed: "Sydney",
    serviceAreaLatLong: {
        latitude: -33.9180, // Sydney
        longitude: 151.0346
    }

}

export const businessDetails: BusinessDetails = {
    branding: {
        headerLogoUrl: "/images/logos/header-logo.svg",
        footerLogoUrl: "/images/logos/footer-logo.svg",
    },
    companyData: {
        abn: "93 143 294 400",
        address: "PO Box 5427, Chullora NSW 2190",
        licenseNumber: "Licence Number:226539C",
    },
    captchaKeys: {
        dev: "6LeDLn4UAAAAAPW2RFlXvgusfkU9e_n4Q7zFtpQj",
        prod: "6LcP3p0oAAAAAOLrgJTbudQ5pkckcNng9CJtxr1M",
    },
    address: {
        streetAddress: "123 High St",
        addressLocality: "Bankstown",
        addressRegion: "NSW",
        postalCode: "2200",
        addressCountry: "AU"
    },
    serviceAreas: [
        "Sydney CBD",
        "Inner West",
        "Eastern Suburbs",
        "Lower North Shore",
        "Upper North Shore",
        "Northern Beaches",
        "Western Sydney",
        "Southern Sydney",
        "Sutherland Shire",
        "Greater Western Sydney",
    ],
    generalServiceArea:'Sydney'
};
